const SnackbarIconClose = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_13925_242)">
  <path d="M18 6L6 18" stroke="#875BF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M6 6L18 18" stroke="#875BF7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
  <clipPath id="clip0_13925_242">
  <rect width="24" height="24" fill="white"/>
  </clipPath>
  </defs>
  </svg>
)

export default SnackbarIconClose